import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { extend2, PROJECT_VERSION, pluckNumber, pluck, RGBtoHex } from '../../../fc-core/src/lib';
import { ComponentInterface } from '../../../fc-core/src/component-interface';
import { downloadCharts, browserDetails, drawSvgOnCanvas, isCanvasElemSupported } from '../utils/lib-svg-to-canvas';
import { JpegToPdf, addImage, getDataUrl } from '../utils/jpeg-to-pdf';
import { EXPORTACTION, EXPORTMODE, EXPORTFORMAT, LOGMODE, createExportActionOldString, cacheAllImages, makeImageUrlsAbsolute, embedImagesWithNonDataURL, replaceImagesWithNonDataUrl, hasUndownloadableImage, logCharts, svgStrToDataUrl } from '../utils/export-utils';

var isObject = function isObject(a) {
  return 'object' == typeof a;
},
    getBackgroundColor = function getBackgroundColor(a) {
  var b = pluckNumber(a.options.containerBackgroundOpacity, 1);
  return a.jsVars.transparent || 0 === b ? '' : a.options.containerBackgroundColor || '#FFFFFF';
},
    getBackgroundAlpha = function getBackgroundAlpha(a) {
  return a.jsVars.transparent ? 0 : pluckNumber(a.options.containerBackgroundOpacity, 1) + '';
},
    IMAGEDATA = 'IMAGE-DATA',
    xAttrRegx = /\s\bx\b=['"][^'"]+?['"]/ig,
    yAttrRegx = /\s\by\b=['"][^'"]+?['"]/ig,
    win = window,
    doc = win.document,
    DEFAULT_EXPORT_URL = 'https:' === win.location.protocol ? 'https://export.api3.fusioncharts.com/' : 'http://export.api3.fusioncharts.com/',
    DEFAULT_LOG_URL = 'https:' === win.location.protocol ? 'https://export.api3.fusioncharts.com/api/v1.0/logs' : 'http://export.api3.fusioncharts.com/api/v1.0/logs',
    isIOS = win.navigator.userAgent.match(/(iPad|iPhone|iPod)/g);

var ExportModule =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(ExportModule, _ComponentInterface);

  function ExportModule() {
    var _this;

    _classCallCheck(this, ExportModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportModule).call(this)), _this.config = {
      exportOption: {},
      chartConfig: {
        caption: '',
        subcaption: '',
        width: '',
        height: ''
      }
    };
    return _this;
  }

  _createClass(ExportModule, [{
    key: "getName",
    value: function getName() {
      return 'exportModule';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'extension';
    }
  }, {
    key: "configureMenuBar",
    value: function configureMenuBar() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g,
          h,
          j = this,
          k = j.getFromEnv('chart'),
          l = j.getFromEnv('toolbar'),
          m = !!win.btoa,
          n = j.getFromEnv('chart-attrib').exportformats,
          o = l.getChild("hamburgerMenu-".concat(l.getId(), "-").concat(k.getId(), "-0")),
          p = {
        PNG: 'Export As ' + EXPORTFORMAT.PNG.toUpperCase(),
        JPG: 'Export As ' + EXPORTFORMAT.JPG.toUpperCase(),
        PDF: 'Export As ' + EXPORTFORMAT.PDF.toUpperCase(),
        SVG: 'Export As ' + EXPORTFORMAT.SVG.toUpperCase(),
        XLS: 'Export As ' + EXPORTFORMAT.XLS.toUpperCase()
      },
          q = [];

      if (j.config.exportOption.exportenabled) {
        if (f = function f(a) {
          return function () {
            j.config.exportOption.exportformat = a, j.exportChart({});
          };
        }, n) for (a = n.split('|'), d = 0, e = a.length; d < e; d++) {
          b = a[d].split('='), c = b[0].toUpperCase(), p[c] && (p[c] = b[1] || p[c]), p[c] && (h || (h = {})) && (h[c] = !0);
        }

        for (c in p) {
          ('XLS' !== c || m) && (!h || h[c]) && (g = {
            name: p[c],
            handler: f(c),
            action: 'click'
          }, q.push(g));
        }

        o.appendInMenu(q);
      }
    }
  }, {
    key: "configure",
    value: function configure(a) {
      var b = this.getFromEnv('chartInstance'),
          c = this.config,
          d = c.chartConfig,
          e = c.exportOption;
      a = a.chartConfig, a.caption && (d.caption = pluck(a.caption, '')), a.subcaption && (d.subcaption = pluck(a.subcaption, '')), e.exportenabled = pluckNumber(a.exportenabled, 0), e.exportshowmenuitem = pluckNumber(a.exportshowmenuitem, 1), e.exportformat = pluck(a.exportformat, EXPORTFORMAT.PNG), e.exporthandler = pluck(a.html5exporthandler, a.exporthandler, DEFAULT_EXPORT_URL), e.exportaction = function () {
        var b;
        return a.exportaction && 'string' == typeof a.exportaction ? (b = a.exportaction.toLowerCase(), 0 <= [EXPORTACTION.DOWNLOAD, EXPORTACTION.SAVE, EXPORTACTION.DOWNLOADSAVE].indexOf(b) ? b : EXPORTACTION.DOWNLOAD) : EXPORTACTION.DOWNLOAD;
      }(), e.exporttargetwindow = pluck(a.exporttargetwindow, isIOS ? '_parent' : '_self'), e.exportfilename = pluck(a.exportfilename, 'FusionCharts'), e.exportparameters = pluck(a.exportparameters, ''), e.exportcallback = pluck(a.exportcallback, ''), e.exportwithimages = pluckNumber(a.exportwithimages, 1), e.exportmode = function () {
        var b;
        return 'undefined' != typeof a.exportatclientside && (b = {
          1: EXPORTMODE.AUTO,
          0: EXPORTMODE.AUTO
        }[a.exportatclientside]), b = a.exportmode || b || EXPORTMODE.AUTO, b = b.toLowerCase(), b;
      }(), e.logenabled = pluckNumber(a.logenabled, 0), e.loghandler = pluck(a.html5loghandler, a.loghandler, DEFAULT_LOG_URL), e.logmode = function () {
        var b = a.logmode;
        return 'undefined' != typeof b && 'string' == typeof b && b.toUpperCase() in LOGMODE ? LOGMODE[b.toUpperCase()] : LOGMODE.AUTO;
      }(), e.bgcolor = getBackgroundColor(b), e.bgalpha = getBackgroundAlpha(b), e.exportshowmenuitem && this.configureMenuBar();
    }
  }, {
    key: "exportChart",
    value: function exportChart(a) {
      var b,
          c,
          d,
          e,
          f = this.getFromEnv('chartInstance'),
          g = this.getFromEnv('chart'),
          h = this.config.exportOption,
          i = isObject(a) && function (a) {
        var b,
            c = {};

        for (b in a) {
          c[b.toLowerCase()] = a[b];
        }

        return c;
      }(a) || {},
          j = extend2(extend2({}, h), i),
          k = (j.exportformat || EXPORTFORMAT.PNG).toLowerCase(),
          l = j.exporthandler,
          m = j.exportaction,
          n = j.exporttargetwindow || '',
          o = j.exportfilename,
          p = j.exportparameters,
          q = j.exportcallback,
          r = j.exportwithimages,
          s = j.exportmode,
          t = j.logenabled,
          u = j.loghandler,
          v = j.logmode,
          w = this;

      g.fireChartInstanceEvent('beforeExport', j, e, function () {
        var a,
            h,
            i,
            x,
            y,
            z,
            A,
            B = f.id,
            C = w.config.chartConfig.caption,
            D = w.config.chartConfig.subcaption,
            E = this.apiInstance.getFromEnv('paper'),
            F = this.apiInstance.getFromEnv('core-options')['export'].useCanvas,
            G = g.getChildren('chartMenuBar')[0],
            H = G.getChild("hamburgerMenu-".concat(G.getId(), "-").concat(g.getId(), "-0")),
            I = H.getChild('listContainer'),
            J = isCanvasElemSupported(),
            K = {
          DOMId: B,
          height: E.height,
          width: E.width,
          fileName: o + '.' + k,
          statusCode: e,
          statusMessage: e,
          notice: e
        },
            L = {
          exportAction: m,
          exportTargetWindow: n,
          exportCallback: q,
          fusionCharts: f,
          paper: E,
          chartId: B,
          exportHandler: l,
          logEnabled: t,
          logMode: v,
          logHandler: u
        },
            M = function M(a, b, c) {
          var d, e, g, h;
          return c = c || m, d = m, e = createExportActionOldString(m), g = ['exportfilename=' + o, 'exportformat=' + k, 'exportaction=' + e, 'exportactionnew=' + d, 'configuredexportaction=' + c, 'exportparameters=' + p].join('|'), h = !!t, v === LOGMODE.CLIENT && (h = !1), {
            charttype: f.chartType(),
            stream_type: a || '',
            stream: b || '',
            meta_bgColor: j.bgcolor || '',
            meta_bgAlpha: j.bgalpha || '1',
            meta_DOMId: f.id,
            meta_width: E.width || w.config.chartConfig.width,
            meta_height: E.height || w.config.chartConfig.height,
            chart_caption: C,
            chart_sub_caption: D,
            is_single_export: !0,
            is_full_version: !1,
            version: PROJECT_VERSION,
            user_time_zone: -new Date().getTimezoneOffset(),
            log_enabled: h,
            parameters: g
          };
        },
            N = function N() {
          var a = m;
          return {
            chartType: f.chartType(),
            chartCaption: C,
            chartSubCaption: D,
            isSingleExport: !0,
            isFullVersion: !1,
            exportAction: a,
            userTimeZone: -new Date().getTimezoneOffset(),
            exportFileName: [o, k].join('.'),
            exportFormat: k,
            version: PROJECT_VERSION
          };
        },
            O = function O(a) {
          var b = M(EXPORTFORMAT.SVG, a);
          downloadCharts(null, null, null, b, L);
        },
            P = function P(a) {
          var b,
              c,
              d = hasUndownloadableImage(a);
          browserDetails.hasCanvas && 'undefined' != typeof win.btoa ? (b = doc.createElement('canvas'), b.width = E.width, b.height = E.height, a = embedImagesWithNonDataURL(a), i = replaceImagesWithNonDataUrl(i), d || k === EXPORTFORMAT.SVG ? (c = M(EXPORTFORMAT.SVG, a), downloadCharts(null, null, null, c, L)) : drawSvgOnCanvas({
            svg: i,
            canvas: b,
            x: 0,
            y: 0,
            width: E.width,
            height: E.height,
            useCanvas: F
          }, function () {
            var a;

            switch (k) {
              case EXPORTFORMAT.PNG:
                a = b.toDataURL('image/png');
                break;

              case EXPORTFORMAT.JPEG:
                a = b.toDataURL('image/jpeg');
                break;

              case EXPORTFORMAT.PDF:
                JpegToPdf(E.height, E.width), addImage(b.toDataURL('image/jpeg')), a = getDataUrl();
                break;

              default:
                a = b.toDataURL('image/jpeg');
            }

            c = M(IMAGEDATA, a), downloadCharts(null, null, null, c, L);
          })) : O(a);
        },
            Q = function Q(a, b, c) {
          var d;
          d = doc.createElement('canvas'), d.width = E.width, d.height = E.height, drawSvgOnCanvas({
            svg: i,
            canvas: d,
            x: 0,
            y: 0,
            width: E.width,
            height: E.height,
            useCanvas: F
          }, function () {
            switch (a) {
              case EXPORTFORMAT.PNG:
                b(a, d.toDataURL('image/png'), o, c);
                break;

              case EXPORTFORMAT.JPEG:
                b(a, d.toDataURL('image/jpeg'), o, c);
                break;

              case EXPORTFORMAT.PDF:
                b(a, d.toDataURL('image/jpeg'), o, c);
                break;

              default:
                b(a, d.toDataURL('image/jpeg'), o, c);
            }
          });
        },
            R = function R(b, c, d, e, f) {
          b === EXPORTFORMAT.PDF && (JpegToPdf(E.height, E.width), addImage(c), c = getDataUrl()), a = f === EXPORTMODE.AUTO ? M(IMAGEDATA, c) : null, downloadCharts('url', c, d + '.' + b, a, e);
        },
            S = function S(a, b, c) {
          var d, e;
          k === EXPORTFORMAT.SVG ? (d = svgStrToDataUrl(a), c(d, b)) : (e = function e() {
            c(arguments[1], b);
          }, Q(k, e, b));
        },
            T = function T(b, c, d) {
          var e, f, g;
          e = o + '.' + k, k === EXPORTFORMAT.SVG ? (f = svgStrToDataUrl(b), a = d === EXPORTMODE.AUTO ? M(IMAGEDATA, f) : null, downloadCharts('url', f, e, a, c)) : (g = function g() {
            R(arguments[0], arguments[1], arguments[2], arguments[3], d);
          }, Q(k, g, c));
        },
            U = function U() {
          var a = 0;
          b = [], c.replace(/[^\r\n]+/g, function (c) {
            b[a] = [], b[a] = c.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(function (a) {
              return a.replace(/"/g, '');
            }), a += 1;
          });
        },
            V = function V() {
          function a() {
            var a, c, d, e, f, g, h;
            if (!b.length) return '';

            for (a = '<table align=\'center\' >', e = 0, h = b.length; e < h; e += 1) {
              if (0 === e) {
                for (c = '<thead valign=\'top\'><tr>', f = 0, g = b[e].length; f < g; f += 1) {
                  c += '<th>' + b[e][f] + '</th>';
                }

                c += '</tr></thead>', d = '<tbody>';
              } else {
                for (d += '<tr>', f = 0, g = b[e].length; f < g; f += 1) {
                  d += '<td>' + b[e][f] + '</td>';
                }

                d += '</tr>';
              }
            }

            return d += '</tbody>', a + c + d + '</table>';
          }

          return 'data:application/vnd.ms-excel;base64,' + function (a) {
            return win.btoa(win.unescape(encodeURIComponent(a)));
          }('<!DOCTYPE HTML PUBLIC "-//IETF//DTD HTML//EN"><html xmlns:o=\'urn:schemas-microsoft-com:office:office\'xmlns:x=\'urn:schemas-microsoft-com:office:excel\'xmlns=\'http://www.w3.org/TR/REC-html40\'><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>' + a() + '</body></html>');
        },
            W = function W(a) {
          g.fireChartInstanceEvent('exportDataReady', a);
        },
            X = function X(a) {
          a === LOGMODE.CLIENT && logCharts(N(), L);
        };

        if ('xls' === k) {
          if ('undefined' != typeof win.btoa) c = f.getCSVData();else return g.fireChartInstanceEvent('exportCancelled', j), !1;
          W(), U(), d = V(), y = 'undefined' != typeof win.btoa && ('Chrome' === browserDetails.name || 'Firefox' === browserDetails.name || 'Safari' === browserDetails.name || 'Edge' === browserDetails.name || 'ie' === browserDetails.name), 'server' !== s && y ? ((m === EXPORTACTION.DOWNLOAD || m === EXPORTACTION.DOWNLOADSAVE) && (downloadCharts('url', d, o + '.' + k, null, L), g.fireChartInstanceEvent('exported', K)), m === EXPORTACTION.SAVE || m === EXPORTACTION.DOWNLOADSAVE ? (z = m, m === EXPORTACTION.DOWNLOADSAVE && (m = EXPORTACTION.SAVE), a = M(IMAGEDATA, d, z), downloadCharts(null, null, null, a, L), X(v)) : v !== LOGMODE.SERVER && logCharts(N(), L)) : (a = M(IMAGEDATA, d), downloadCharts(null, null, null, a, L), X(v));
        } else x = I.getLinkedParent().getGraphicalElement('button', 'button'), x && x.attr('visibility', 'hidden'), h = E.toSVG(r), i = E.toSVG(r && J), i = i.replace(/&nbsp;/ig, ' '), x && x.attr('visibility', 'visible'), h = h.replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/ig, '$1M 0 0 L 0 0$2'), h = h.replace(/NS\d+:/gi, 'xlink:'), h = h.replace(/&nbsp;/ig, ' '), i = i.replace(/NS\d+:/gi, 'xlink:'), i = i.replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/ig, '$1M 0 0 L 0 0$2'), i = i.replace(/(xlink:title\s*=\s*)['"].*["']/ig, ''), h = h.replace(/[\w\-]+\=\"undefined\"/ig, ''), h = h.replace(/(xlink:title\s*=\s*)['"].*["']/ig, ''), h = h.replace(/rgba\(([^\)]+)\)/ig, function (a) {
          return '#' + new RGBtoHex(a.split(','));
        }), h = h.replace(/<svg[^>]+/i, function (a) {
          return !a.match(/height/i) && (E.height || w.config.chartConfig.height) && (a += ' height="' + (E.height || w.config.chartConfig.height) + '"'), !a.match(/width/i) && (E.width || w.config.chartConfig.width) && (a += ' width="' + (E.width || w.config.chartConfig.width) + '"'), a;
        }), h = h.replace(/(([\w]+\-)?opacity\s*=\s*)['"][\d\.]+e[\-\+][\d]+["']/ig, '$1"0.001"'), h = h.replace(/(([\w]+\-)?opacity\s*:\s*)[\d\.]+e[\-\+][\d]+/ig, '$10.001'), h = h.replace(/<text[^\>]+/ig, function (a) {
          return a = a.replace(/stroke\=[\"\']([a-z0-9\#]+)?[\"\']/ig, ''), a = a.replace(/stroke\s*\:\s*([a-z0-9\#]+)?;?/ig, ''), a = a.replace(/stroke-width\=[\"\']([a-z0-9\#]+)?[\"\']/ig, ''), a = a.replace(/stroke-width\s*\:\s*([a-z0-9\#]+)?;?/ig, ''), a = a.replace(/stroke-opacity\=[\"\']([a-z0-9\#]+)?[\"\']/ig, ''), a = a.replace(/stroke-opacity\s*\:\s*([a-z0-9\#]+)?;?/ig, ''), a = a.replace(/(<text[^\>]+fill\=)([\"\'][^\"\']+[\"\'])([^\>]+)/ig, '$1$2 stroke=$2 stroke-width="0.2"$3'), a = a.replace(/(<text[^\>]+fill-opacity\=)([\"\'][^\"\']+[\"\'])([^\>]+)/ig, '$1$2 stroke-opacity=$2 $3'), a;
        }), h = h.replace(/<(\b[^<>s\s]+\b)[^\>]+?opacity\s*=\s*['"][^1][^\>]+?(\/>|>[\s\r\n]*?<\/\1>)/ig, function (a, b) {
          var c,
              d = xAttrRegx.exec(a) || '',
              e = yAttrRegx.exec(a) || '';
          return c = ' opacity="1" stroke-opacity="1" fill="#cccccc" stroke-width="0" r="0"', c += ' height="0.5" width="0.5" d="M 0 0 L 1 1" />', a + '<' + b + d + e + c;
        }), h = makeImageUrlsAbsolute(h), i = makeImageUrlsAbsolute(i), A = s === EXPORTMODE.SERVER, cacheAllImages(h, A, function () {
          a = M(EXPORTFORMAT.SVG, h), W(a), a = null;
          var b,
              c = 'undefined' != typeof win.btoa && ('Chrome' === browserDetails.name || 'Firefox' === browserDetails.name || 'Safari' === browserDetails.name || 'Edge' === browserDetails.name || 'ie' === browserDetails.name),
              d = hasUndownloadableImage(h);
          (s === EXPORTMODE.CLIENT || s === EXPORTMODE.AUTO && !d) && c ? (i = replaceImagesWithNonDataUrl(i), (m === EXPORTACTION.DOWNLOAD || m === EXPORTACTION.DOWNLOADSAVE) && (T(i, L, s), g.fireChartInstanceEvent('exported', K)), m === EXPORTACTION.SAVE || m === EXPORTACTION.DOWNLOADSAVE ? (b = m, m === EXPORTACTION.DOWNLOADSAVE && (m = EXPORTACTION.SAVE), S(i, L, function (c, d) {
            a = M(IMAGEDATA, c, b), downloadCharts(null, null, null, a, d), X(v);
          }), g.fireChartInstanceEvent('exported', K)) : v !== LOGMODE.SERVER && logCharts(N(), L)) : s === EXPORTMODE.AUTO ? (P(h), X(v)) : s === EXPORTMODE.SERVER && (O(h), X(v));
        });
      }, function () {
        g.fireChartInstanceEvent('exportCancelled', j);
      });
    }
  }]);

  return ExportModule;
}(ComponentInterface);

export { ExportModule as default };